import React, { useState } from "react";
import { Modal, Button, Form, message } from "antd";
import QuestionForm from "../../Components/QuestionForm/QuestionForm";
import axiosInstance from "../../Config/axiosConfig";

const Questions = ({ subjects }) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAddQuestion = async (values) => {
    try {
      setLoading(true);

      await axiosInstance.post("/questions/create", values);
      message.success("Question added successfully");

      form.resetFields();
      setVisible(false);
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to save question");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setVisible(true)}>
        Add Question
      </Button>

      <Modal
        title="Add Question"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={800}
      >
        <QuestionForm
          form={form}
          subjects={subjects}
          onSubmit={handleAddQuestion}
          loading={loading}
          submitText="Add Question"
        />
      </Modal>
    </>
  );
};

export default Questions;
